import { ReactElement } from 'react';
import { SwitcherProps } from '../Agenda.types';

export default function Switcher({
  on,
  changeHandler,
  reverse,
  invertColors,
  color,
  idleColor,
  className,
  disabled,
}: SwitcherProps): ReactElement {
  const selectedColor = color || 'primary';
  const nonSelectedColor = idleColor || 'white';

  return (
    <div
      className={
        'flex mx-2 border rounded-full w-10 h-6 my-auto shadow-md cursor-pointer transition duration-150 ease-in-out ' +
        (invertColors
          ? on
            ? ' bg-' + selectedColor
            : ' bg-base-200'
          : on
            ? ' bg-' + nonSelectedColor
            : ' bg-base-200') +
        ' ' +
        (reverse
          ? !on
            ? ' flex-row'
            : ' flex-row-reverse'
          : on
            ? ' flex-row'
            : ' flex-row-reverse bg-base-200') +
        (className ? ' ' + className : '')
      }
      onClick={() => {
        if (disabled) return;
        changeHandler(!on);
      }}
    >
      <div
        className={
          ' rounded-full my-auto flex transition duration-150 ease-in-out ' +
          (invertColors ? 'w-4 h-4 mx-1' : 'w-5 h-5') +
          (invertColors ? ' bg-' + nonSelectedColor : ' bg-' + selectedColor)
        }
      ></div>
    </div>
  );
}
